var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-card-status",class:[_vm.status]},[_c('div',{staticClass:"project-card-status-text"},[_vm._v(_vm._s(_vm.$t('status_'+_vm.status)))])])}
var staticRenderFns = []

export { render, staticRenderFns }